export const environment = {
  production: false,
  apiBaseUrl: 'https://tnebackend.dmqifs.site/api',
};